import { lazy, Suspense } from 'react';
import { LandingPage } from './landing/LandingPage';
import { ErrorBoundary } from './landing/components/shared';
import './index.css';

const WidgetPreviewPage = lazy(() =>
  import('./landing/components/widgets/WidgetPreviewPage').then((m) => ({
    default: m.WidgetPreviewPage,
  }))
);

const ContactSalesPage = lazy(() =>
  import('./landing/components/pages/ContactSalesPage').then((m) => ({
    default: m.ContactSalesPage,
  }))
);

function App() {
  const path = window.location.pathname;

  if (path === '/widgets') {
    return (
      <Suspense fallback={null}>
        <WidgetPreviewPage />
      </Suspense>
    );
  }

  if (path === '/contact') {
    return (
      <Suspense fallback={null}>
        <ContactSalesPage />
      </Suspense>
    );
  }

  return <LandingPage />;
}

export default function AppWithBoundary() {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}
